import { fadeInDown } from "react-animations";
import styled, { keyframes } from "styled-components";
import Color from "../../../assets/styles/colors";

const fadeInDownAnimation = keyframes`${fadeInDown}`;

export const Div = styled.div``;

export const Row = styled.div``;

export const Col = styled.div``;

export const Container = styled.div`
  animation: 1s ${fadeInDownAnimation};
`;

export const CardLink = styled.a``;

export const ShippingTitle = styled.span`
  font-size: 13px;
  color: ${(props) =>
    props.theme.isDarkTheme
      ? Color.textColorBlackSeven
      : Color.textColorBlackSix};
`;

export const ShippingMsg = styled.span`
  font-size: 12px;
  color: ${Color.textColorBlackTow};
`;

export const ShippingIcon = styled.i`
  color: ${Color.textColorBlackTow};
`;
